var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ "js-cursor-down": _vm.hasCursorDown },on:{"touchstart":_vm.touchStart,"touchmove":_vm.touchMove,"touchend":_vm.touchEnd,"mousedown":_vm.touchStart,"mousemove":_vm.touchMove,"mouseup":_vm.touchEnd,"mouseleave":_vm.touchEnd,"!click":function($event){_vm.blockClick($event)},"wheel":_vm.onWheel,"dragstart":function($event){$event.preventDefault();}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41eeb05f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/swipe.vue
// module id = 604
// module chunks = 0